import React from 'react';
import useClientPanels from '../custom-hooks/useClientPanels';

function ClientPanels (props) {
  const [clientPanels, isLoading] = useClientPanels();
  if (isLoading === true) {
    return <p>Loading...</p>;
  }

    return (
        <div className="panelHolder" id="clientPanelHolder">
            <h1 id="clientTitle">OUR CLIENTS</h1>
            <div id="clientTiles" className="row">
            {clientPanels.map((cPanel, index) => {
                const svgString = cPanel.fields.svgCode;
                let panelClass = "col-sm-6 col-lg-4 ";
                if (index === 8) {
                    panelClass += "middlePanel";
                }
      return (
            <div className={panelClass} key={cPanel.fields.clientName}>
                <div className="panelLogo">
                    <img className="clientLogo img-fluid mx-auto" src={cPanel.fields.logo.fields.file.url} alt={cPanel.fields.logo.fields.title} />
                </div>
                <h2 className="panelTitle clientName">{cPanel.fields.clientName}</h2>
                <p className="panelText">{cPanel.fields.description}</p>
            </div>
      );
    })}
            </div>
        </div>
    );


}

export default ClientPanels;
